module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp13_7005.12d6b41b.png";